import { createStore } from '@blufin/react-core';

export interface AppSelectabilityStoreState {
  /** When true, the app root should suppress text selection (eg: while a drag is in progress). */
  appIsUnselectable: boolean;
}

export interface IAppSelectabilityStore {
  getState: () => AppSelectabilityStoreState;
  setUnselectable: (value: boolean) => void;
  use: <U>(selector: (state: AppSelectabilityStoreState) => U) => U;
}

const initialState: AppSelectabilityStoreState = {
  appIsUnselectable: false
};

const store = createStore<AppSelectabilityStoreState>({ ...initialState });

export const AppSelectabilityStore: IAppSelectabilityStore = {
  /** Returns the current selectability snapshot. */
  getState: store.getState,
  /**
   * Set whether the app root should be unselectable. Components that initiate a drag call
   * this with `true` on pointer-down and `false` when the drag ends.
   * @param value - The new unselectable state.
   */
  setUnselectable: value => store.setState({ appIsUnselectable: value }),
  /** React hook that subscribes to a slice of state via `useSyncExternalStore`. */
  use: store.use
};
